import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {useLocation} from 'react-router-dom';
import {
    Switch,
    FormControlLabel,
    Button,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    TextField,
} from '@mui/material';
import CustomLoader from "../../../components/ConfirmationModal/CustomLoader";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import NomenclatureEnum from "../../../enums/nomenclatureEnum";
import "./ContenteditableFields.css"
import {FaEye, FaTrashAlt} from "react-icons/fa";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function ContenteditableFields() {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingRegistery, setIsLoadingRegistery] = useState(true);
    const [refresh, setRefresh] = useState(false);
    const [error, setError] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false); // Step 2
    const query = useQuery();
    const id = query.get('id');
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const [objectsOfRegistery, setObjectsOfRegistery] = useState([]);
    const [initialSwitchStates, setInitialSwitchStates] = useState({
        editableUserValues: false,
        editableEmployeeValues: false,
        hasParentId: false,
        isEditebleGeoData: false,
        needApprovalDocument: false,
        hasConditionalFinish: false,
        hasOrderDate: false,
        hasExtenstion: false,
        hasBuilidngDocument: false
    });
    const [departmentId, setDepartmentId] = useState(null);
    const [inspectFileDepartmentId, setInspectFileDepartmentId] = useState(null);
    const [orderDepartment, setOrderDepartment] = useState(null);
    const [initialDepartmentId, setInitialDepartmentId] = useState(null);
    const [initialInspectFileDepartmentId, setInitialInspectFileDepartmentId] = useState(null);
    const [initialOrderDepartment, setInitialOrderDepartment] = useState(null);
    const [url, setUrl] = useState('');
    const [initialUrl, setInitialUrl] = useState('');
    const [title, setTitle] = useState('');
    const [initialTitle, setInitialTitle] = useState('');
    const [titleEng, setTitleEng] = useState('');
    const [initialTitleEng, setInitialTitleEng] = useState('');
    const [iconBase64, setIconBase64] = useState('');

    const handleDeleteIcon = () => {
        setIconBase64('');
        const fileInput = document.getElementById('icon-file');
        if (fileInput) {
            fileInput.value = '';
        }
    };


    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file.type !== 'image/svg+xml') {
            setAlert({show: true, message: 'Please upload only SVG files.', type: 'error'});
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setIconBase64(reader.result);
        };
        reader.readAsDataURL(file);
    };


    const checkIfObjectIsInRegistery = (objects, object) => {
        return objects.filter(item => item.id === object).length !== 0
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const data = response.data.data;
                const findLastChildren = (nodes) => {
                    let children = [];
                    nodes.forEach(node => {
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            children = [...children, ...findLastChildren(node.childrenPermitTypes)];
                        } else {
                            children.push(node);
                        }
                    });
                    return children;
                };

                const lastNode = data[data.length - 1];
                const lastNodeChildren = findLastChildren([lastNode]);
                setObjectsOfRegistery(lastNodeChildren);
                setIsLoadingRegistery(false)
            } catch (error) {
            }
        };

        void fetchData();
    }, []);


    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDepartament`);
                if (response.data.success) {
                    setDepartments(response.data.data);
                }
            } catch (error) {
                setError(error.message || 'Error fetching departments');
            }
        };

        void fetchDepartments();
    }, []);


    useEffect(() => {
        const fetchPermitType = async () => {
            try {
                setIsLoading(true);
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeByID?Id=${id}`);
                setData(response.data);
                setDepartmentId(response.data.data.departmentId || 2);
                setInspectFileDepartmentId(response.data.data.inspectFileDepartmentId || 1);
                setOrderDepartment(response.data.data.orderDepartment);
                setInitialUrl(response.data.data.url);
                setUrl(response.data.data.url);
                setInitialTitle(response.data.data.title);
                setTitle(response.data.data.title);
                setInitialTitleEng(response.data.data.titleEng);
                setTitleEng(response.data.data.titleEng);

                setInitialSwitchStates({
                    editableUserValues: response.data.data.editableUserValues || false,
                    editableEmployeeValues: response.data.data.editableEmployeeValues || false,
                    hasParentId: response.data.data.hasParentId || false,
                    isEditebleGeoData: response.data.data.isEditebleGeoData || false,
                    needApprovalDocument: response.data.data.needApprovalDocument || false,
                    hasConditionalFinish: response.data.data.hasConditionalFinish || false,
                    hasOrderDate: response.data.data.hasOrderDate || false,
                    hasExtenstion: response.data.data.hasExtenstion || false,
                    hasBuilidngDocument: response.data.data.hasBuilidngDocument || false,
                });
                setInitialDepartmentId(response.data.data.departmentId);
                setInitialInspectFileDepartmentId(response.data.data.inspectFileDepartmentId);
                setInitialOrderDepartment(response.data.data.orderDepartment);

            } catch (error) {
                setError(error);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            void fetchPermitType();
        }
    }, [id, refresh]);


    const isSaveDisabled = () => {
        if (iconBase64 !== '') {
            return false;
        }
        return initialSwitchStates.editableUserValues === (data?.data.editableUserValues || false) &&
            initialSwitchStates.editableEmployeeValues === (data?.data.editableEmployeeValues || false) &&
            initialSwitchStates.isEditebleGeoData === (data?.data.isEditebleGeoData || false) &&
            initialSwitchStates.hasParentId === (data?.data.hasParentId || false) &&
            initialSwitchStates.needApprovalDocument === (data?.data.needApprovalDocument || false) &&
            initialSwitchStates.hasConditionalFinish === (data?.data.hasConditionalFinish || false) &&
            initialSwitchStates.hasOrderDate === (data?.data.hasOrderDate || false) &&
            initialSwitchStates.hasExtenstion === (data?.data.hasExtenstion || false) &&
            initialSwitchStates.hasBuilidngDocument === (data?.data.hasBuilidngDocument || false) &&
            initialInspectFileDepartmentId === inspectFileDepartmentId &&
            orderDepartment === initialOrderDepartment &&
            url === initialUrl &&
            title === initialTitle &&
            titleEng === initialTitleEng &&
            initialDepartmentId === departmentId;
    };

    const handleEditSubmit = async () => {
        try {
            setIsLoading(true);
            const updateData = {
                permitTypeId: parseInt(id),
                title: title,
                titleEng: titleEng,
                icon: iconBase64 || data.data.icon,
                url: url,
                departmentId: departmentId,
                inspectFileDepartmentId: inspectFileDepartmentId,
                orderDepartment: orderDepartment,
                editableUserValues: data.data.editableUserValues,
                editableEmployeeValues: data.data.editableEmployeeValues,
                hasParentId: data.data.hasParentId,
                isEditebleGeoData: data.data.isEditebleGeoData,
                needApprovalDocument: data.data.needApprovalDocument,
                hasConditionalFinish: data.data.hasConditionalFinish,
                hasOrderDate: data.data.hasOrderDate,
                hasExtenstion: data.data.hasExtenstion,
                hasBuilidngDocument: data.data.hasBuilidngDocument,
            };
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdatePermitType`, updateData);
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});
        } catch (error) {
            setAlert({show: true, message: 'Error updating data!', type: 'error'});
        } finally {
            setRefresh(!refresh);
            setIsLoading(false);
            setIsModalOpen(false);
        }
    };


    const handleSwitchChange = (event) => {
        setData({
            ...data,
            data: {
                ...data.data,
                [event.target.name]: event.target.checked,
            }
        });
    };


    if (isLoading || isLoadingRegistery) return <CustomLoader/>;
    if (error) return <div>Error: {error.message}</div>;
    if (!data) return <div>No data found</div>;

    return (
        <div className={"ContenteditableFields-Container"}>

            <div className={"case-settings"}>

                <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                    <TextField
                        fullWidth
                        style={{marginBottom: '20px'}}
                        label="სახელი"
                        variant="outlined"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <TextField
                        fullWidth
                        style={{marginBottom: '20px'}}
                        label="სახელი ინგლისურად"
                        variant="outlined"
                        value={titleEng}
                        onChange={(e) => setTitleEng(e.target.value)}
                    />
                    {objectsOfRegistery.length !== 0 && checkIfObjectIsInRegistery(objectsOfRegistery, parseInt(id)) && (
                        <FormControl fullWidth style={{marginBottom: '20px'}}>
                            <InputLabel id="department-label">ინსპექტორების დეპარტამენტი</InputLabel>
                            <Select
                                labelId="department-label"
                                value={inspectFileDepartmentId}
                                label="ინსპექტორების დეპარტამენტი"
                                onChange={(e) => setInspectFileDepartmentId(e.target.value)}
                            >
                                {departments.map((department) => (
                                    <MenuItem key={department.id} value={department.id}>
                                        {department.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}

                    <FormControl fullWidth style={{marginBottom: '20px'}}>
                        <InputLabel id="department-label">დეპარტამენტი</InputLabel>
                        <Select
                            labelId="department-label"
                            value={departmentId}
                            label="დეპარტამენტი"
                            onChange={(e) => setDepartmentId(e.target.value)}
                        >
                            {departments.map((department) => (
                                <MenuItem key={department.id} value={department.id}>
                                    {department.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth style={{marginBottom: '20px'}}>
                        <InputLabel id="department-label">ნომენკლატურა</InputLabel>
                        <Select
                            labelId="department-label"
                            value={orderDepartment}
                            label="ნომენკლატურა"
                            onChange={(e) => setOrderDepartment(e.target.value)}
                        >
                            <MenuItem key={NomenclatureEnum.building} value={NomenclatureEnum.building}>
                                მშენბებლობის ნებართვა
                            </MenuItem>
                            <MenuItem key={NomenclatureEnum.explosion} value={NomenclatureEnum.explosion}>
                                სამრეწველო დანიშნულების ფეთქებადი მასალების გამოყენების ნებართვა
                            </MenuItem>
                            <MenuItem key={NomenclatureEnum.registery} value={NomenclatureEnum.registery}>
                                მომეტებული საფრთხის შემცვლელი ობიექტის რეგისტრაცია
                            </MenuItem>

                        </Select>
                    </FormControl>

                    {objectsOfRegistery.length !== 0 && checkIfObjectIsInRegistery(objectsOfRegistery, parseInt(id)) && (
                        <div className={"icon-upload-container"}>
                            <input
                                type="file"
                                accept="image/svg+xml"
                                onChange={handleFileChange}
                                style={{display: 'none'}}
                                id="icon-file"
                            />
                            <label htmlFor="icon-file" className="upload-button-fields">
                                ლოგოს ატვირთვა <FaEye/>
                            </label>
                            {iconBase64 && (
                                <div className="icon-preview">
                                    <img src={iconBase64} alt="Icon preview" className="icon-image"/>
                                    <div onClick={handleDeleteIcon} className="file-icon delete-icon">
                                        <FaTrashAlt/>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    <div className="url-container">
                        <div className="url-origin">{window.location.origin}</div>
                        <TextField
                            fullWidth
                            label="დამხამარე გვერდის მისამართი"
                            variant="outlined"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                        />
                    </div>


                    {/*<FormControlLabel*/}
                    {/*    control={<Switch checked={data.data.editableUserValues || false} onChange={handleSwitchChange}*/}
                    {/*                     name="editableUserValues"/>}*/}
                    {/*    label="თანამშრომლის ველების რედაქტირება"*/}
                    {/*/>*/}
                    {/*<FormControlLabel*/}
                    {/*    control={<Switch checked={data.data.editableEmployeeValues || false}*/}
                    {/*                     onChange={handleSwitchChange} name="editableEmployeeValues"/>}*/}
                    {/*    label="მომხმარებლის ველების რედაქტირება"*/}
                    {/*/>*/}
                    <FormControlLabel
                        control={<Switch checked={data.data.hasParentId || false} onChange={handleSwitchChange}
                                         name="hasParentId"/>}
                        label="ებმევა სხვა განაცხადს"
                    />
                    {/*<FormControlLabel*/}
                    {/*    control={<Switch checked={data.data.isEditebleGeoData || false} onChange={handleSwitchChange}*/}
                    {/*                     name="isEditebleGeoData"/>}*/}
                    {/*    label="ტერიტორიული მონაცემების რედაქტირება"*/}
                    {/*/>*/}
                    {/*<FormControlLabel*/}
                    {/*    control={<Switch checked={data.data.needApprovalDocument || false} onChange={handleSwitchChange}*/}
                    {/*                     name="needApprovalDocument"/>}*/}
                    {/*    label="დადასტურების ასატვირთი დოკუმენტი"*/}
                    {/*/>*/}
                    <FormControlLabel
                        control={<Switch checked={data.data.hasConditionalFinish || false} onChange={handleSwitchChange}
                                         name="hasConditionalFinish"/>}
                        label="სრულდება პირობით"
                    />
                    <FormControlLabel
                        control={<Switch checked={data.data.hasOrderDate || false} onChange={handleSwitchChange}
                                         name="hasOrderDate"/>}
                        label="აქვს ნებართვის ვადა"
                    />
                    <FormControlLabel
                        control={<Switch checked={data.data.hasExtenstion || false} onChange={handleSwitchChange}
                                         name="hasExtenstion"/>}
                        label="წარმოების ვადის გაგრძელება"
                    />
                    <FormControlLabel
                        style={{marginBottom: 100}}
                        disabled={orderDepartment !== NomenclatureEnum.building}
                        control={<Switch checked={data.data.hasBuilidngDocument || false} onChange={handleSwitchChange}
                                         name="hasBuilidngDocument"/>}
                        label="ჩანს სანებართვო მოწმობის რეპორტში"
                    />

                    <Button
                        style={{marginBottom: 20}}
                        variant="contained"
                        color="primary"
                        onClick={() => setIsModalOpen(true)}
                        disabled={isSaveDisabled()}>
                        შენახვა
                    </Button>
                </div>
            </div>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={handleEditSubmit}
            />
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
        </div>
    );
}

export default ContenteditableFields;
